/*************************************************/
/* FOOTER                                        */
/*************************************************/
export function footer() {
    const accordionHeads = document.querySelectorAll('.footer__section-headline');

    const init = () => {
        if (accordionHeads) {
            accordionHeads.forEach(head => {
                head.addEventListener("click", () => {
                    var links = head.nextElementSibling;
                    var accordionItems = links.querySelectorAll('.footer__section-link');

                    head.classList.toggle('footer__section-headline--active');

                    accordionItems.forEach(item => {
                        item.classList.toggle('footer__section-link--active');
                    })
                })
            })
        }
    };

    init();
}